import { Component, Injectable, Input, Output, EventEmitter } from "@angular/core";
import { NGXLogger } from "ngx-logger";

@Injectable()
export class ServiceLinkService {
    isElectricity:boolean;
    isInternet:boolean;
    isTelephone:boolean;
    isWater:boolean;
    isGas:boolean;
    isCityCorp:boolean;
    isEducationBoard:boolean;
    isLandMistry:boolean;
    isPassport:boolean;
    isLandPortAuthority:boolean;
    isEservice:boolean;
    isMunicipality:boolean;
    isOther:boolean;
    isTopup: boolean;
    isInstitute: boolean;

    selectedService: string;
    @Output() fire: EventEmitter<any> = new EventEmitter();

    constructor(private logger: NGXLogger) {
        this.logger.debug("calling service link service...")
    }
}



// WEBPACK FOOTER //
// ./src/app/payment/service-links/service-links-service.ts